import React, { Component } from "react";
import ModalAdd from "../resep/modalAddresep";
import API from "../../../apiService";
import { DetilPxContext } from "../../../context";
import "./style.css";
import Alert, { confirmedAlert, showLoading, toast } from "../../component/Alert";
import print from "print-js";
import apiService from "../../../apiService";
import ModalChangeBatch from "./modalChangeBatch";
import ModalChangeJumlah from "./modalChangeJumlah";
import Rekonsiliasi from "./Rekonsiliasi";
import TelaahModal from "../TelaahResep/TelaahModal";

export default class resep extends Component {
  static contextType = DetilPxContext;
  constructor(props) {
    super(props);
    this.state = {
      detilPx: this.props.detilPx,
      drugs: [],
      drugsMix: [],
      modalShow: false,
      modalChangeShow: false,
      modalChangeJumlahShow: false,
      profile: JSON.parse(localStorage.getItem("puskesmasProfile")),
      diag: [],
      rekonsiliasi_obat: [],
      anamnese: {},
      changedMix: false,
      changedDrug: null,
      changedDrugDetail: null,
      changedJumlahDrug: null,
      changedJumlahDrugDetail: null,
      show: false,
      selectedData: []
    };
    this.parentCallback = this.parentCallback.bind(this);
    this.PrescribeServed = this.PrescribeServed.bind(this);
    this.served = this.served.bind(this);
    this.componentRefx = React.createRef();
    this.printEtiket = this.printEtiket.bind(this);
  }

  componentDidMount() {
    this.prescribesGet(this.state.detilPx.id);
    this.getAnamnese(this.state.detilPx.id);
  
  }


  getAnamnese = async id => {
    let res = await API.get(`/management/anamneses/read?visit_id=` + id);
    if (res.code === 200 && res.data.length) {
      let rekon = res.data[0].rekonsiliasi_obat
      if (rekon) {
        rekon = JSON.parse(rekon)
      }
      else {
        rekon = []
      }
      this.setState({
        rekonsiliasi_obat: rekon,
        anamnese: res.data[0]
      })
    }
  }

  prescribesGet = async (id) => {
    let res = await API.get(`/registration/prescribe/read?visit_id=${id}&clinic_id=${this.props.detilPx.clinics.drug_clinic_id}`);
    if (res.code === 200) {
      let drugsMix = [];
      let drugs = [];

      res.data.map((prescribes, y) => {
        prescribes.available_qty = (prescribes.details[0]?.drug_in_detail[0]?.stock_in?.qty ?? 0) - (prescribes.details[0]?.drug_in_detail[0]?.stock_out?.qty ?? 0)
        prescribes.details = prescribes.details.map(v => ({ ...v, available_qty: (v.drug_in_detail[0]?.stock_in?.qty ?? 0) - (v.drug_in_detail[0]?.stock_out?.qty ?? 0) }))
        if (prescribes.combination_name !== "") {
          drugsMix.push(prescribes);
        } else {
          //coba tambah resep dalam dan luar
          drugs.push(prescribes);
        }
        return null;
      });

      let new_drugs = []
      drugs.forEach(drug => {
        if (drug.drug_taken_date) {
          drug.details.filter(v => v.accepted).forEach(detail => {
            new_drugs.push({ ...drug, details: [detail] })
          })
        }
        else {
          new_drugs.push(drug)
        }
      })

      this.setState({
        drugs: new_drugs,
        drugsMix,
        diag: res.data ? res.data[0].diagnoses : [],
      });
    } else {
      // ALERT("error", "gagal menyimpan data");
    }
  };

  drgDelete = async (pr, index) => {
    confirmedAlert(
      "Peringatan",
      "Apakah anda akan menghapus resep obat?",
      async (confirmed) => {
        if (confirmed) {
          let drugsMix = this.state.drugsMix;
          let drugs = this.state.drugs;

          let res = await API.delete(
            `/registration/prescribe/delete_mix/` + pr
          );
          if (res.code === 200) {
            if (res.data.combination_name !== "") {
              drugsMix[index].log = true;
            } else {
              drugs[index].log = true;
            }
            this.setState({
              drugs,
              drugsMix,
            });
            try {
              Alert(
                "success",
                "Berhasil Menghapus Data",
                "Notifikasi Pelayanan Obat"
              );
            } catch (error) { }
          } else {
            // ALERT("error", "gagal menyimpan data");
          }
        }
      }
    );
  };

  served = async (e, noted, ky, diagnose, status, recipe, drug = null) => {
    if (status === "racikan") {
      let drugsMix = this.state.drugsMix;
      let param = {
        id: e,
        note: noted,
        diagnose: diagnose,
        inside_recipe: recipe,
        details: drug.details
      };
      let res = await API.put(`/registration/prescribe/take_drug`, param);
      if (res.code === 200) {
        drugsMix[ky].drug_taken_date = res.data.drug_taken_date;
        this.setState({
          drugsMix,
        });
      }
    } else {
      let drugs = this.state.drugs;
      let param = {
        id: e,
        note: noted,
        diagnose: diagnose,
        details: drug?.new_detail ? [drug?.new_detail] : []
      };
      let res = await API.put(`/registration/prescribe/take_drug`, param);
      if (res.code === 200) {
        // ALERT("success", "Berhasil Menyimpan Data ");
        drugs[ky].drug_taken_date = res.data.drug_taken_date;
        this.setState({
          drugs,
        });
      }
    }
    try {
      Alert("success", "Berhasil Menyimpan Data", "Notifikasi Pelayanan Obat");
    } catch (error) { }
  };

  parentCallback(data) {
    this.setState((prevState) => ({
      detilPx: {
        // object that we want to update
        ...prevState.detilPx, // keep all other key-value pairs
        [data.param]: data.data,
      },
    }));
    this.prescribesGet(this.state.detilPx.id);
  }

  async PrescribeServed() {
    const batch_perlu_diedit_tp_belum = this.state.drugs.filter(drug => {
      if (drug.log || drug.drug_taken_date) {
        return false
      }
      if (!drug.new_detail) {
        return drug.details[0]?.qty > drug.available_qty && !drug.drug_taken_date && !drug.details[0]?.log
      }
      else {
        return +drug.new_detail.qty > +drug.new_detail.available_qty && !drug.drug_taken_date
      }
    })
    const batch_mix_perlu_diedit_tp_belum = this.state.drugsMix.filter(drug => {
      if (drug.log || drug.drug_taken_date) {
        return false
      }
      return drug.details.some(v => v.qty > v.available_qty && !v.log)
    })
console.log(batch_perlu_diedit_tp_belum, batch_mix_perlu_diedit_tp_belum );
    if (batch_perlu_diedit_tp_belum.length) {
      const drug = batch_perlu_diedit_tp_belum[0]
      alert(`Jumlah obat ${drug.details[0].drug.name} no batch ${drug.details[0].drug_in_detail[0].batch_number} perlu diedit`)
      return
    }
    if (batch_mix_perlu_diedit_tp_belum.length) {
      const drug = batch_mix_perlu_diedit_tp_belum[0]
      const detail = drug.details.find(v => v.qty > v.available_qty && !v.log)
      alert(`Jumlah obat ${detail.drug.name} no batch ${detail.drug_in_detail[0].batch_number} perlu diedit`)
      return
    }

    let obat = this.state.drugs;
    let obatMix = this.state.drugsMix;
    obat.map(async (dr, key) => {
      if (dr.drug_taken_date === null) {
        await this.served(
          dr.id,
          dr.note,
          key,
          dr.diagnose,
          "non racikan",
          dr.inside_recipe,
          dr
        );
      }
    });
    obatMix.map(async (dr, key) => {
      if (dr.drug_taken_date === null) {
        await this.served(
          dr.id,
          dr.note,
          key,
          dr.diagnose,
          "racikan",
          dr.inside_recipe,
          dr
        );
      }
    });
    await apiService.post(
      `fhir/satu_sehat/medication_dispense/${this.state.detilPx.id}`
    );
  }

  printEtiket = async (e) => {
    let id = this.state.detilPx.id;
    let res = await API.getblob(`registration/prescribe/print?visit_id=` + id);
    if (res) {
      const file = new Blob([res], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      print(fileURL);
    }
  };

  printKitir = async (e) => {
    let id = this.state.detilPx.id;
    let res = await API.getblob(`/registration/print?visit_id=` + id);
    if (res) {
      const file = new Blob([res], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      print(fileURL);
    }
  };

  changeNote(x, y, z) {
    if (y === "racikan") {
      let drugsMix = this.state.drugsMix;
      drugsMix[x].note = z.target.value;
      this.setState({ drugsMix });
    } else {
      let drugs = this.state.drugs;
      drugs[x].note = z.target.value;
      this.setState({ drugs });
    }
  }

  changeValue(x, y, z) {
    if (y === "racikan") {
      let drugsMix = this.state.drugsMix;
      drugsMix[x][y] = z;
      this.setState({ drugsMix });
    } else {
      let drugs = this.state.drugs;
      drugs[x][y] = z;
      this.setState({ drugs });
    }
  }
  pilihData() {
    this.setState({ selectedData: this.props }, () => this.setState({ show: true }))
  }
  render() {
    let drugs = this.state.drugs.length > 0 ? this.state.drugs : [];
    let Pdrugs = drugs.map((drug, key) => {
      if (drug.log === false) {
        return (
          <div key={key} className="card">
            <div
              className="card-header"
              data-toggle="collapse"
              data-target={"#resepDrug" + key}
              aria-expanded="true"
              aria-controls={"collapseDrug" + key}
            >
              <div className="row">
                <div className="col-md-2">
                  <label className="custom-toggle custom-toggle-success">
                    <input
                      type="checkbox"
                      checked={drug.inside_recipe ? "checked" : ""}
                      onChange={(e) =>
                        this.changeValue(key, "inside_recipe", e.target.checked)
                      }
                    // onChange={(e) => console.log(e.target.checked)}
                    />
                    <span
                      className="custom-toggle-slider rounded-circle"
                      data-label-off=" luar"
                      data-label-on="dalam"
                    />
                  </label>
                </div>
                <div className="col-md-10">
                  {drug.drug_taken_date ? (
                    <span
                      className="badge badge-info badge-pill mr-1"
                    >
                      {drug.diagnoses.find((e) => e.icd_code == drug.diagnose)
                        ? drug.diagnoses.find(
                          (e) => e.icd_code == drug.diagnose
                        ).icd_name
                        : ""}
                    </span>
                  ) : (
                    <select
                      className="form-control-sm"
                      style={{ maxWidth: "100%" }}
                      onChange={(e) =>
                        this.changeValue(key, "diagnose", e.target.value)
                      }
                    >
                      <option>Icd</option>
                      {drug.diagnoses?.map((a) => (
                        <option
                          value={a.icd_code}
                        >{`${a.icd_code} ${a.icd_name}`}</option>
                      ))}
                    </select>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <span className="badge badge-success badge-pill mr-1">
                    Klinik {drug.visit.clinics.name}
                  </span>
                  <span className="badge badge-primary badge-pill mr-1">
                    non-racikan
                  </span>
                </div>
                <div className="col-md-5 h4">
                  {drug.details[0]?.drug?.name}
                  <br />
                  {!drug.new_detail && (
                    <span style={{ fontWeight: 'normal' }}>
                      Batch: {drug.details[0]?.drug_in_detail[0]?.batch_number} <br />
                      {!drug.drug_taken_date && <span className={drug.details[0]?.qty > drug.available_qty ? 'text-danger' : ''}>
                        Jumlah Tersedia: {drug.available_qty}
                      </span>}
                      {drug.details[0]?.qty > drug.available_qty && !drug.drug_taken_date && (
                        <button
                          className={'ml-1 btn btn-sm btn-success'}
                          onClick={() => {
                            this.setState({ changedDrug: drug, changedDrugDetail: drug.details[0], modalChangeShow: true, changedMix: false })
                          }}>
                          <i className={'fa fa-sync'}></i>
                        </button>
                      )}
                    </span>
                  )}
                  {drug.new_detail && (
                    <span style={{ fontWeight: 'normal' }}>
                      Batch: {drug.new_detail.batch_number ?? drug.details[0]?.drug_in_detail[0]?.batch_number} <br />
                      {!drug.drug_taken_date && <span className={drug.new_detail.qty > drug.new_detail.available_qty ? 'text-danger' : ''}>
                        Jumlah Tersedia: {drug.new_detail.available_qty}
                      </span>}
                      {drug.new_detail.qty > drug.new_detail.available_qty && !drug.drug_taken_date && (
                        <button
                          className={'ml-1 btn btn-sm btn-success'}
                          onClick={() => {
                            this.setState({ changedDrug: drug, changedDrugDetail: drug.details[0], modalChangeShow: true, changedMix: false })
                          }}>
                          <i className={'fa fa-sync'}></i>
                        </button>
                      )}
                    </span>
                  )}
                  <br />
                  {drug.drug_taken_date === null ? (
                    <span className="badge badge-danger badge-pill">
                      belum dilayani
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-2">
                  <div>{"Jumlah = " + (drug.new_detail ? drug.new_detail.qty : drug.details[0]?.qty)}</div>
                  {drug.drug_taken_date === null && <button className="btn btn-warning btn-sm" onClick={() => {
                    this.setState({
                      changedJumlahDrug: drug,
                      changedJumlahDrugDetail: drug.new_detail ? drug.new_detail : drug.details[0],
                      modalChangeJumlahShow: true,
                    })
                  }}>
                    <i className="fa fa-pencil"></i>
                  </button>}
                </div>
                <div className="col-md-3">{drug.signa.name}</div>
              </div>
            </div>
            <div
              id={"resepDrug" + key}
              className="collapse show"
              aria-labelledby={"heading" + key}
            // data-parent="#accordionExample"
            >
              <div className="form-group row mb-0 card-body">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label col-form-label-sm"
                >
                  <b>Catatan</b>
                </label>
                <div className="col-md-8">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      id="example-text-input"
                      name="catatan"
                      onChange={(e) => this.changeNote(key, "", e)}
                      value={drug ? drug.note : ""}
                    />
                  </div>
                </div>
                {drug.drug_taken_date === null ? (
                  <div className="col-md-2 text-right">
                    <button
                      className="btn btn-danger"
                      onClick={() => this.drgDelete(drug.id, key)}
                    >
                      -{" "}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        );
      }
    });
    let drugsMix = this.state.drugsMix.length > 0 ? this.state.drugsMix : [];
    let PdrugsMix = drugsMix.map((drug, key) => {
      if (drug.log === false) {
        return (
          <div key={key} className="card">
            <div
              className="card-header"
              data-toggle="collapse"
              data-target={"#resep" + key}
              aria-expanded="true"
              aria-controls={"collapse" + key}
            >
              <div className="row">
                <div className="col-md-2">
                  <span className="badge badge-success badge-pill mr-1">
                    Klinik {drug.visit.clinics.name}
                  </span>
                  <span className="badge badge-default badge-pill mr-1">
                    obat racikan
                  </span>
                </div>
                <div className="col-md-5 h4">
                  {drug.combination_name}
                  <br />
                  {drug.drug_taken_date === null ? (
                    <span className="badge badge-danger badge-pill">
                      belum dilayani
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-2">
                  {"Jumlah = " + drug.combination_qty}
                </div>
                <div className="col-md-3">{drug.signa.name}</div>
              </div>
            </div>
            <div
              id={"resep" + key}
              className="collapse show"
              aria-labelledby={"heading" + key}
            // data-parent="#accordionExample"
            >
              <div className="card-body mb-0 gray-900">
                <div className="list-group">
                  {drug.details.map((dr, ky) => {
                    if (dr.log === false) {
                      return (
                        <div key={ky} className="list-group-item text-default">
                          <div className="row m-0">
                            <div className="col-md-7">
                              <h4 className="mb-0 text-default">
                                {dr.drug.name}
                              </h4>
                              {!dr.new && (
                                <span style={{ fontWeight: 'normal' }}>
                                  Batch: {dr.drug_in_detail[0]?.batch_number} <br />
                                  {!drug.drug_taken_date && <span className={dr.qty > dr.available_qty ? 'text-danger' : ''}>
                                    Jumlah Tersedia: {dr.available_qty}
                                  </span>}
                                  {dr.qty > dr.available_qty && !drug.drug_taken_date && (
                                    <button
                                      className={'ml-1 btn btn-sm btn-success'}
                                      onClick={() => {
                                        this.setState({ changedDrug: drug, changedDrugDetail: dr, modalChangeShow: true, changedMix: true })
                                      }}>
                                      <i className={'fa fa-sync'}></i>
                                    </button>
                                  )}
                                </span>
                              )}
                              {dr.new && (
                                <span style={{ fontWeight: 'normal' }}>
                                  Batch: {dr.batch_number} <br />
                                  {!drug.drug_taken_date && <span className={dr.qty > dr.available_qty ? 'text-danger' : ''}>
                                    Jumlah Tersedia: {dr.available_qty}
                                  </span>}
                                  {dr.qty > dr.available_qty && !drug.drug_taken_date && (
                                    <button
                                      className={'ml-1 btn btn-sm btn-success'}
                                      onClick={() => {
                                        this.setState({ changedDrug: drug, changedDrugDetail: dr, modalChangeShow: true, changedMix: true })
                                      }}>
                                      <i className={'fa fa-sync'}></i>
                                    </button>
                                  )}
                                </span>
                              )}
                            </div>
                            <div className="col-md-5">
                              <span>{"Jumlah = " + dr.qty}</span>
                            </div>
                          </div>
                        </div>
                      );
                    }
                    return <></>;
                  })}
                </div>
              </div>
              <div className="card-footer">
                <div className="form-group row mb-0">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-2 col-form-label col-form-label-sm"
                  >
                    <b>Catatan</b>
                  </label>
                  <div className="col-md-8">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      id="example-text-input"
                      name="catatan"
                      onChange={(e) => this.changeNote(key, "racikan", e)}
                      value={drug ? drug.note : ""}
                    />
                  </div>

                  {drug.drug_taken_date === null ? (
                    <div className="col-md-2 text-right">
                      <button
                        className="btn btn-danger"
                        onClick={() => this.drgDelete(drug.id, key)}
                      >
                        -
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      }
    });
    return (
      <div>
        <Rekonsiliasi
          rekonsiliasi_obat={this.state.rekonsiliasi_obat}
          anamnese={this.state.anamnese}
          setAnamnese={v => {
            let rekon = v.rekonsiliasi_obat
            this.setState({ rekonsiliasi_obat: rekon ? JSON.parse(rekon) : [], anamnese: v })
          }}
          add={() => {
            this.setState({ rekonsiliasi_obat: [...this.state.rekonsiliasi_obat, { name: '', signa1: '', signa2: '', new: true }] })
          }}
          cancelNew={() => {
            this.setState({ rekonsiliasi_obat: this.state.rekonsiliasi_obat.filter(v => !v.new) })
          }}
        />

        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-8">
                <h4 className="h3 mb-0">Form Pelayanan Resep</h4>
              </div>
              <div className="col-4 text-right">
                <button
                  className="btn btn-sm btn-neutral"
                  onClick={this.printEtiket}
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-print"></i>
                  </span>
                  <span className="btn-inner--text"> Cetak E-Tiket</span>
                </button>
              </div>
            </div>
          </div>
          <div className="card-body accordion bg-secondary">
            {Pdrugs}
            {PdrugsMix}
          </div>
          <div className="card-footer">
            <div className={'d-flex'}>
              {/* <div className="row"> */}
              <TelaahModal show={this.state.show} data={this.state.selectedData}
              onHide={() => this.setState({ show: false })} />
            <button
              className="btn btn-primary"
              onClick={() => this.pilihData()}
            >
              Telaah Resep
            </button>
              <button
                className="btn btn-primary"
                onClick={() => this.setState({modalShow: true})}
              >
                Tambah Resep
              </button>
              <button className="btn btn-success" onClick={this.PrescribeServed}>
                Layani Resep
              </button>
              <button className="btn btn-secondary" onClick={this.printKitir}>
                Print Kitir
              </button>
              <div style={{flex: 1}}></div>
              <button className="btn btn-danger" onClick={() => this.props.history.push("/PelayananObatList")}>
                Tutup
              </button>
            </div>
          </div>
        </div>
        <ModalAdd
          patient={this.state.detilPx}
          show={this.state.modalShow}
          drugs={this.state.drugs}
          drugsmix={this.state.drugsMix}
          onHide={() => {
            this.setState({ modalShow: false });
            this.prescribesGet(this.state.detilPx.id);
          }}
        />
        <ModalChangeJumlah
          show={this.state.modalChangeJumlahShow}
          onHide={() => this.setState({ modalChangeJumlahShow: false })}
          drug={this.state.changedJumlahDrug}
          detail={this.state.changedJumlahDrugDetail}
          onSave={async qty => {
            this.setState({ modalChangeJumlahShow: false })
            showLoading('Menyimpan jumlah')
            let data = await apiService.post("/registration/prescribe/change_jumlah", {
              id: this.state.changedJumlahDrugDetail?.id ?? 0,
              qty
            });
            if (data.code === 200) {
              await this.prescribesGet(this.state.detilPx.id)
              toast({ status: "success", text: "Berhasil menyimpan" })
            }
            else {
              toast({ status: "warning", text: "Gagal menyimpan" })
            }
          }}
        />
        <ModalChangeBatch
          show={this.state.modalChangeShow}
          onHide={() => this.setState({ modalChangeShow: false })}
          onSave={(list) => {
            if (this.state.changedMix) {
              let newMix = [...this.state.drugsMix]
              list.forEach(l => {
                const idx = newMix.findIndex(m => m.id === this.state.changedDrug.id)
                if (idx !== -1) {
                  let newDetails = [...newMix[idx].details]
                  const detailsIdx = newDetails.findIndex(d => l.prescribe_detail_id === d.id && d.id)
                  if (detailsIdx !== -1) {
                    newDetails[detailsIdx] = { ...l, id: l.prescribe_detail_id, new: true, log: false }
                  }
                  else {
                    newDetails.push({ ...l, id: 0, new: true, log: false })
                  }
                  newMix[idx].details = newDetails
                }
              })
              this.setState({ drugsMix: newMix, modalChangeShow: false })
            }
            else {
              let drugs = [...this.state.drugs]
              const changed = drugs.find(v => v.id === this.state.changedDrug.id)
              const changedIndex = drugs.findIndex(v => v.id === this.state.changedDrug.id)
              drugs.splice(changedIndex, 1, ...list.map(v => ({ ...changed, new_detail: { ...v, id: !v.prescribe_id ? 0 : changed.details[0].id } })))
              this.setState({ drugs, modalChangeShow: false })
            }
          }}
          drug={this.state.changedDrug}
          detail={this.state.changedDrugDetail}
          visit={this.props.detilPx}
        />
      </div>
    );
  }
}
